export const getColor = (index: number) => {
  switch (index) {
    case 1:
      return 'linear-gradient(180deg, #786CFB 0%, #76AFF1 100%)';
    case 2:
      return 'linear-gradient(180deg, #25BA7A 0%, #00B3DD 100%)';
    case 3:
      return 'linear-gradient(180deg, #F2739A 0%, #E660CD 100%)';
    case 4:
      return 'linear-gradient(164.51deg, #F37498 0%, #FCB74A 100%)';
    default:
      return 'linear-gradient(164.51deg, #08A0CA 0%, #03E2DA 100%)';
  }
};
